<template>
  <li>
    <router-link target="_blank" :to="`/investment_info_park_detail?incubator_id=${itemObj.id}`">
      <div class="img_box">
        <img v-lazy="itemObj.coverPath" />
        <div class="levels" v-if="itemObj.levels">{{itemObj.levels}}</div>
        <div class="view">{{itemObj.popularity || 0}}浏览</div>
      </div>
      <div class="gardenList_inner_box">
        <h3>{{itemObj.name}}</h3>
        <p>{{itemObj.province_name}}{{itemObj.city_name}}</p>
        <div>
          <span>{{itemObj.price || '面议'}}</span>
          <span v-if="itemObj.price">起/工位/月</span>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    itemObj: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.gardenList_box {
  width: 100%;
  ul {
    display: flex;
    flex-wrap: wrap;
    li:nth-child(3n) {
      margin-right: 0;
    }
    li:hover {
      box-shadow: 0 0 24px 0 rgba(130, 146, 171, 0.46);
    }
    li {
      width: 386px;
      background: #fff;
      margin: 0 20px 20px 0;
      border: 1px solid #eeeeee;
      box-sizing: border-box;
      & > a {
        position: relative;
      }

      .img_box {
        width: 100%;
        height: 288px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          background: $bg-darkgray;
        }
        .view {
          position: absolute;
          min-width: 60px;
          padding: 7px 7px 5px;
          background: rgba(0, 0, 0, 0.3);
          box-sizing: border-box;
          color: #fff;
          font-size: 12px;
          text-align: center;
          right: 10px;
          top: 254px;
        }
        .levels {
          min-width: 60px;
          box-sizing: border-box;
          text-align: center;
          position: absolute;
          top: 10px;
          right: 10px;
          background: rgba(0, 0, 0, 0.3);
          color: #ffff;
          display: inline-block;
          white-space: nowrap;
          padding: 5px 10px;
          z-index: 1;
          border-radius: 4px;
          font-size: 12px;
        }
      }

      .gardenList_inner_box {
        padding: 13px 20px 4px;
        h3 {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 30px;
          font-size: 16px;
          font-weight: 600;
          color: #343434;
        }
        p {
          line-height: 28px;
          font-size: 14px;
          font-weight: 400;
          color: #9a9a9a;
        }
        div {
          line-height: 38px;
          color: #ff4e5a;
          span:nth-child(1) {
            font-size: 18px;
            vertical-align: middle;
            padding-right: 8px;
          }
          span:nth-child(2) {
            font-size: 14px;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .no_data {
    text-align: center;
    padding: 40px 0;
    p {
      color: #a4a8ba;
      font-size: 14px;
    }
  }
}
</style>
